export async function fetchNews() {
    try {
        const res = await fetch('/news/posts.json', { cache: 'no-store' }); // no-store pour dev, retirez si cache voulu
        if (!res.ok) {
            throw new Error(`Fetch news failed: ${res.status}`);
        }
        const data = await res.json();
        return data.posts || [];
    } catch (err) {
        console.error(err);
        return [];
    }
}